import { useState, useEffect } from 'react';

// Same public key the pages send to the data API (see APIKeyMiddleware).
const api_key = 'seh3599f@fUERkdf22&^2{u'

// One lookup per page load, shared by every component that asks. The backend
// caches the location per client IP, so this is cheap even alongside the pages
// that call /api/getlocation/ themselves. Resolves to
// { country, showIhtToNonUk }: the visitor's two-letter country code (null if
// unknown, e.g. localhost or a failed lookup) and the admin setting for
// showing UK inheritance tax material to visitors outside the UK.
let locationPromise = null;
const UNKNOWN = { country: null, showIhtToNonUk: false };

const fetchLocation = () => {
  if (!locationPromise) {
    locationPromise = fetch('/api/getlocation/', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-API-KEY': api_key,
      },
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => (data ? { country: data.country || null, showIhtToNonUk: data.show_iht_to_non_uk === true } : UNKNOWN))
      .catch(() => UNKNOWN);
  }
  return locationPromise;
};

const useLocation = () => {
  const [location, setLocation] = useState(UNKNOWN);

  useEffect(() => {
    let cancelled = false;
    fetchLocation().then((result) => {
      if (!cancelled) setLocation(result);
    });
    return () => { cancelled = true; };
  }, []);

  return location;
};

// Two-letter country code of the visitor (e.g. 'GB'), or null while the
// lookup is pending or if it failed / returned no country.
const useUserCountry = () => useLocation().country;

// Whether this visitor should see the UK inheritance tax functions,
// references and guide material: always in the UK; outside it only if the
// admin setting (MiscInputData.show_iht_to_non_uk_visitors) is on. A visitor
// whose location is unknown or still being looked up is treated as in the UK,
// so a lookup problem never hides the material from UK users.
export const useUkIhtVisible = () => {
  const { country, showIhtToNonUk } = useLocation();
  return showIhtToNonUk || country === null || country === 'GB';
};

export default useUserCountry;
